"use strict";

exports.__esModule = true;
exports.AlertsIcon = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AlertsIcon = exports.AlertsIcon = function AlertsIcon(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    width: props.width,
    height: props.height,
    viewBox: "0 0 55 55"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M28 1L1 47h54L28 1zm2 12.3l-.6 20.1h-2.8L26 13.3h4zm-2 28.6c-1.5 0-2.5-1.1-2.5-2.6s1-2.6 2.5-2.6 2.5 1.1 2.5 2.6-1 2.6-2.5 2.6z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};